import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private auth: AuthService) { }

    canActivate() {
        if (!this.auth.isAuthenticated()) {
            this.auth.login();
        }

        return true;
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/auth-guard.service.ts